export default __webpack_public_path__ + "static/media/MAXIS_3.fda15fef.gif";